document.querySelectorAll( '.wp-block-acf-animation' ).forEach( ( lottie ) => {
  const lottieAnimation = lottie.querySelector( '.js-lottie-player, lottie-player' )
  const pauseButton = lottie.querySelector( '.lottie__pause' )
  const playButton = lottie.querySelector( '.lottie__play' )

  if ( ! lottieAnimation || ! pauseButton || ! playButton ) {
    return
  }

  pauseButton.addEventListener( 'click', () => {
    lottieAnimation.pause()
    pauseButton.classList.add( 'paused' )
  } )

  playButton.addEventListener( 'click', () => {
    lottieAnimation.play()
    pauseButton.classList.remove( 'paused' )
  } )
} )
